import {Directive, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2} from "@angular/core";
import {NgControl} from "@angular/forms";
import {INInputMaskAccessor} from "./index";

const Inputmask = require("inputmask");

@Directive({
  selector: "[inputMask]",
})
export class InputMaskDirective implements OnChanges {

  @Input("inputMask") mask: string;
  @Input() placeholder: string;
  @Input() inputMode: string;
  @Output() maskCleared = new EventEmitter();
  @Output() maskCompleted = new EventEmitter();
  @Output() maskIncomplete = new EventEmitter();

  private inputElement: any;
  private valueAccessor: INInputMaskAccessor;
  private firstCheck = true;

  constructor(
    private el: ElementRef,
    private control: NgControl,
    private renderer: Renderer2
  ) {
    this.valueAccessor = control.valueAccessor as INInputMaskAccessor;
  }

  private checkPropagation() {
    // We have to stop validation before first editing. Don't need to show errors at first time client input.
    if (this.firstCheck) {
      // Stop to move input data to model if it's first time client input
      this.valueAccessor.disablePropagation();
    } else {
      // Otherwise pass input data to model. And validation starts to work.
      this.valueAccessor.enablePropagaton();
      this.valueAccessor.onChange(this.inputElement.inputmask.unmaskedvalue());
    }
  }

  ngOnChanges(): void {
    if (!this.control) {
      console.warn("No control for InputMaskDirective");
      return;
    }
    if (!this.mask) {
      throw new Error("Input mask not specified");
    }

    const options: any = {};

    if (!this.inputElement) {
      this.inputElement = this.valueAccessor.getInputElement ? this.valueAccessor.getInputElement() : this.el.nativeElement;

      if (this.placeholder) {
        this.renderer.setAttribute(this.inputElement, "placeholder", this.placeholder);
      }
    }

    Inputmask.remove(this.inputElement);
    options.autoUnmask = true;
    this.checkPropagation();

    options.oncomplete = () => {
      this.firstCheck = false;
      this.checkPropagation();
      this.maskCompleted.emit();
    };
    options.onincomplete = () => {
      this.firstCheck = false;
      this.checkPropagation();
      this.maskIncomplete.emit();
    };
    options.oncleared = () => {
      this.maskCleared.emit();
    };
    options.onKeyDown = () => {
      this.checkPropagation();
    };

    if (this.inputMode) {
      this.renderer.setAttribute(this.inputElement, "inputmode", this.inputMode);
    }

    Inputmask(this.mask, options).mask(this.inputElement);
  }
}
